import HomeContainer from "../home/HomeContainer";

const categories = [
  { postType: 'PT050', title: '전체', sectionTitle: '자유홍보광고' }
];

const OpenAds = () => {
  return (
    <HomeContainer usePinPost={true} categories={categories} />
  );
}

export default OpenAds;